import { connect } from 'react-redux'
import ContractComponent from '../../../components/employer/contract/contract.component'
import {
  getEmployerContractList,
  getLightEntrepreneurs,
  getTotalApplications
} from '../../../actions/employer'

const mapStateToProps = (state) => {
  return {
    state,
    lightEntre: state.lightEntrepreneurs.lightEntre,
    contractRowsData: state.contracts.contractRows
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getLightEntrepreneurs: () => dispatch(getLightEntrepreneurs()),
    getEmployerContractList: () => dispatch(getEmployerContractList()),
    getTotalApplications: () => dispatch(getTotalApplications())
  }
}

const ContractContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractComponent)

export default ContractContainer
